import * as React from "react";

const SvgIcnAppDegraded = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 2.013l4.988 4.99a1.411 1.411 0 010 1.995L9 13.987a1.411 1.411 0 01-1.995 0l-4.99-4.99a1.411 1.411 0 010-1.995l4.99-4.989a1.411 1.411 0 011.995 0zM8.801 10.4a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-.809-4.8h.017c.488.006.858.474.782.995l-.342 1.79c-.033.237-.223.415-.446.415H8c-.223 0-.413-.178-.446-.415l-.342-1.79c-.076-.521.3-.995.782-.995z"
            fill="#D61F1F"
        />
    </svg>
);

export default SvgIcnAppDegraded;
